import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * The group-wide duplicate view's former address (NAV-84). The page is called
 * "Tools across business units" and lives at `/admin/tools`; nothing on it says
 * "product" — that is the internal word for a tool's identity across business units
 * (ADR 0016), not the reader's.
 */
export const Route = createFileRoute("/admin/products")({
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/admin/tools", search, replace: true });
  },
});
